<template>
  <div>
    <Card>
      <Row>
        <iframe ref="iframe"
                border="none"
                src="https://fresh-admin.chengbao68.com/wechat_auth.html">

        </iframe>
      </Row>
    </Card>
    <Card style="margin-top: 12px">
      <div slot="title">自定义小程序</div>

      <div v-if="wxaAuthorized">
        <Form colon>
          <Form-Item label="小程序 APP SECRET">
            {{ wxa_wechat.authorizer_secret || '[暂未设置]' }}
          </Form-Item>
          <Form-Item label="小程序名称">
            {{ wxa_wechat.wechat_shop_name || '[暂未设置]' }}
          </Form-Item>
          <Form-Item label="小程序欢迎语">
            {{ wxa_wechat.wechat_slogan || '[暂未设置]' }}
          </Form-Item>
          <Form-Item label="小程序登陆页背景图">
            <img v-if="wxa_wechat.background_image"
                 :src="wxa_wechat.background_image"
                 style="width: 100px" />
            <span v-else>[暂未设置]</span>
          </Form-Item>
          <Form-Item label="小程序主题色">
            <div v-if="wxa_wechat.theme"
                 :style="`vertical-align: middle;background-color: ${wxa_wechat.theme}; width: 20px; height: 20px;display: inline-block;`">
            </div>
            {{ wxa_wechat.theme ? '' : '[暂未设置]' }}
          </Form-Item>
          <Form-Item>
            <Button v-if="wxaAuthorized"
                    type="primary"
                    style="margin-left: 8px"
                    @click="onEditWxa">修改</Button>
          </Form-Item>
        </Form>
      </div>
      <div v-else
           class="exa_empty">
        <h2>暂未授权小程序或授权过期，请点击上方授权重新授权</h2>
      </div>

    </Card>
    <Modal v-model="showWxaModal"
           @on-ok="handleSubmitWxa"
           title="小程序设置">
      <Form ref="wxa_wechat"
            :model="wxaForm"
            :label-width="80">
        <Form-item label="小程序 app_secret"
                   prop="authorizer_secret">
          <Input type="text"
                 v-model="wxaForm.authorizer_secret"
                 placeholder="小程序的 APP SECRET" />
        </Form-item>
        <Form-item label="小程序名称"
                   prop="wechat_shop_name">
          <Input type="text"
                 v-model="wxaForm.wechat_shop_name"
                 placeholder="小程序上显示的名称" />
        </Form-item>
        <Form-item label="小程序 slogan"
                   prop="wechat_slogan">
          <Input type="text"
                 v-model="wxaForm.wechat_slogan"
                 placeholder="一句话广告语" />
        </Form-item>
        <Form-item label="小程序登陆页背景图"
                   prop="background_image">
          <uploader @uploadedUrl="uploadedBackground"
                    :url="wxaForm.background_image"></uploader>
        </Form-item>
        <Form-item label="小程序主题色"
                   prop="wechat_theme">
          <input type="color"
                 v-model="wxaForm.wechat_theme" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Uploader from '@/components/uploader-aliyun/single'
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  components: { Uploader },
  data () {
    return {
      modalShow: false,
      auth_url: '',
      iframeReady: false,
      wxaForm: {},
      showWxaModal: false
    }
  },
  created () {
    this.getWxaWechat()
    window.addEventListener('message', this.listenMessage, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.listenMessage)
  },
  computed: {
    ...mapGetters('wechat_config', ['wechat_config']),
    ...mapState('wxa_wechat', ['wxa_wechat']),
    wxaAuthorized () {
      return this.wxa_wechat && Object.keys(this.wxa_wechat).length > 0
    }
  },
  watch: {
    iframeReady (ready) {
      if (ready) {
        this.authorize()
      }
    }
  },
  methods: {
    ...mapActions('wxa_wechat', {
      getWxaWechat: 'find_one',
      updateWxaWechat: 'update'
    }),
    listenMessage (e) {
      const data = e.data
      if (data && data.ready) {
        this.iframeReady = true
      }
    },
    initIframe () {
      const $window = this.$refs.iframe.contentWindow
      // let info = {}
      let token
      const shopId = localStorage.getItem('SHOPID')
      try {
        // info = JSON.parse(localStorage.getItem('session-info'))
        // token = info.auth_token
        token = Cookies.get('token')
      } catch (e) {
        console.error(e)
      }
      $window.postMessage({
        type: 'init',
        authorization: token,
        shopId: shopId,
        shopIdKey: 'ChainStoreId',
        prod: process.env.NODE_ENV === 'production'
      }, '*')
    },
    async authorize () {
      this.initIframe()
      const data = await axios.get('/wxa/componentloginpage')
      this.auth_url = data
      const window = this.$refs.iframe.contentWindow
      window.postMessage({
        type: 'setUrl',
        url: data
      }, '*')
    },
    async onEditWxa () {
      this.showWxaModal = true
      this.wxaForm = { ...this.wxa_wechat }
    },
    async handleSubmitWxa () {
      await this.updateWxaWechat(this.wxaForm)
      this.showWxaModal = false
      await this.getWxaWechat()
    },
    uploadedBackground (url) {
      this.wxaForm.background_image = url
    }
  }
}
</script>

<style scoped>
iframe {
  display: inline-block;
  width: 300px;
  height: 33px;
  border: none;
  overflow: hidden;
  margin-left: 12px;
  transform: translateY(12px);
}

.exa_empty {
  color: #999;
  text-align: center;
  padding: 30px 0;
}
</style>
